import {createAsyncThunk} from "@reduxjs/toolkit";
import {searchApi} from "../../../api/searchApi.js";
import offlineOrTimeoutPromise from "../utils/offlineOrTimeoutPromise.js";

export const allAutocompleteThunk = createAsyncThunk('enhancedSearch/allAutocomplete', async (arg) => {
    const {
        searchText
    } = arg;

    const suggestionApiPromise = searchApi.allAutocomplete(searchText);

    return Promise.race([suggestionApiPromise, offlineOrTimeoutPromise()]);
})
